import { fromJS } from 'immutable';

export default {
    setBrands: (state, brands) => {
        return state.mergeIn(['list'], fromJS(brands));
    }
};



// WEBPACK FOOTER //
// ./environments/fhe/data/Brands/core.js